import { RouteConfig } from 'vue-router'
const IndexTaishan2026 = () => import('./shandong-taishan-2026/Index.vue')
const ShareTaishan2026 = () => import('./shandong-taishan-2026/DouyinSharePage.vue')
const P1RankingTaishan2026 = () => import('./shandong-taishan-2026/P1Ranking.vue')
const RewardsTaishan2026 = () => import('./shandong-taishan-2026/Rewards.vue')
const FinishedRankingTaishan2026 = () => import('./shandong-taishan-2026/FinishedRanking.vue')
// const InviteTaishan2026 = () => import('./shandong-taishan-2026/InviteFriendPage.vue')
const PhysicalRewardSizeEditTaishan2026 = () => import('./shandong-taishan-2026/PhysicalRewardSizeEdit.vue')

export const indexTaishan2026Route: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026',
  name: 'activity_jumprope_match_taishan_2026',
  component: IndexTaishan2026,
  props: (route) => ({ ...route.query, ...route.params, old: '1' }),
  meta: {
    title: '2026“一起爬泰山”',
  },
}

// 新首页
export const indexTaishan2026HomeRoute: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026-home',
  name: 'activity_jumprope_match_taishan_2026-home',
  component: IndexTaishan2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026“一起爬泰山”',
  },
}

export const rewardsTaishan2026Route: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026/rewards',
  name: 'activity_jumprope_match_taishan_2026_rewards',
  component: RewardsTaishan2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}
// export const inviteTaishan2026Route: RouteConfig = {
//   path: '/activity/jumprope-match/taishan-2026/invite',
//   name: 'activity_jumprope_match_taishan_2026_invite',
//   component: InviteTaishan2026,
//   props: (route) => ({ ...route.query, ...route.params }),
//   meta: {
//     title: '邀请好友',
//   },
// }

export const shareTaishan2026Route: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026/share',
  name: 'activity_jumprope_match_taishan_2026_share',
  component: ShareTaishan2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抖音分享',
  },
}
export const p1RankingTaishan2026Route: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026/p1-ranking',
  name: 'activity_jumprope_match_taishan_2026_p1_ranking',
  component: P1RankingTaishan2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '榜单',
  },
}

export const physicalRewardSizeEditTaishan2026Route: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026/physical-reward-size-edit',
  name: 'activity_jumprope_match_taishan_2026_physical_reward_size_edit',
  component: PhysicalRewardSizeEditTaishan2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '尺码选择',
  },
}

export const finishedRankingTaishan2026Route: RouteConfig = {
  path: '/activity/jumprope-match/taishan-2026/finished-ranking',
  name: 'activity_jumprope_match_taishan_2026_finished_ranking',
  component: FinishedRankingTaishan2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '登顶榜单',
  },
}

export default [
  indexTaishan2026Route,
  indexTaishan2026HomeRoute,
  // inviteTaishan2026Route,
  rewardsTaishan2026Route,
  p1RankingTaishan2026Route,
  shareTaishan2026Route,
  physicalRewardSizeEditTaishan2026Route,
  finishedRankingTaishan2026Route,
]
